import React from 'react';
import { ContactsTransferQuestion } from '../../../hooks/subscription/useNumberAssignmentSteps';

interface ContactsTransferTextProps {
  question: ContactsTransferQuestion;
}

/** The contacts transfer question, worded the same in every number assignment modal */
const ContactsTransferText: React.FC<ContactsTransferTextProps> = ({ question }) => {
  const isPlural = question.contactsCount > 1;

  return (
    <>
      <strong>{question.contactsCount} {isPlural ? 'contacts associés' : 'contact associé'}</strong> à{' '}
      <strong>{question.ownerNames}</strong> {isPlural ? 'sont présents' : 'est présent'} sur ce numéro.
      {question.newUserName === null ? (
        <>
          {' '}Voulez-vous {isPlural ? 'les' : 'le'} garder sur le numéro, ou {isPlural ? 'les' : 'le'} déplacer avec {question.ownerNames} ?
          <br />
          {isPlural ? 'Déplacés, ils suivront' : 'Déplacé, il suivra'} {question.ownerNames} : sur {question.ownersCount > 1 ? 'leur' : 'son'} autre numéro, ou sur le prochain {question.ownersCount > 1 ? "qu'ils recevront" : "qu'il recevra"}.
        </>
      ) : (
        <>
          {' '}Voulez-vous {isPlural ? 'les' : 'le'} transférer à <strong>{question.newUserName}</strong> ?
          <br />
          Sinon, {isPlural ? 'ils quittent' : 'il quitte'} ce numéro et {isPlural ? 'restent' : 'reste'} à {question.ownerNames}.
        </>
      )}
    </>
  );
};

export default ContactsTransferText;